var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantLogoMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7297_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 5.99992H6V1.33325H4.66667V5.99992H3.33333V1.33325H2V5.99992C2 7.41325 3.10667 8.55992 4.5 8.64658V14.6666H6.16667V8.64658C7.56 8.55992 8.66667 7.41325 8.66667 5.99992V1.33325H7.33333V5.99992ZM10.6667 3.99992V9.33325H12.3333V14.6666H14V1.33325C12.16 1.33325 10.6667 2.82659 10.6667 3.99992Z",
    fill: "#DBBE78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7297_468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantLogoMaps);
export default __webpack_public_path__ + "static/media/restaurant-logo-maps.9e75bcef603fbb6d92500405f21549f8.svg";
export { ForwardRef as ReactComponent };